import React from "react";
import { Box } from "@mui/material";
import { CONST_SITE_LABEL } from "../Helper";
// import logo from "../../../public/short-logo.png"; // Replace with your logo

const LogoLoader = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      // height="100vh"
      height={'inherit'}
      sx={{ backgroundColor: "#f9f9f9" }}
    >
      <Box
        component="img"
        src={`../${CONST_SITE_LABEL}-short-logo.png`}
        alt="Loading..."
        sx={{
          width: 80,  // Adjust size
          height: 80,
          animation: "spin 2s linear infinite", // Custom animation
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default LogoLoader;
